import React from "react";
import { Icon } from "@qgiv/core-react";
import "./EmployerMatchingNotice.scss";

/**
 * @param {object} props
 * @param {string} props.noticeMessage
 * @returns {React.JSX.Element}
 */
const EmployerMatchingNotice = ({ noticeMessage }) => (
    <div className="col col--12">
        <div className="-callout matching-gift-notice-container">
            <Icon
                ariaHidden
                className="-type--xlarge"
                glyph="gifts-duotone"
                type="FontAwesome"
            />
            <span className="matching-gift-notice-message">
                {noticeMessage}
            </span>
        </div>
    </div>
);

export default EmployerMatchingNotice;
